import React, { useEffect, useState, useRef } from 'react';
import { parseISO, toDate } from 'date-fns';
import {
  MDBContainer,
  MDBBtn,
  MDBModal,
  MDBModalBody,
  MDBModalHeader,
  MDBModalFooter,
  MDBCard,
  MDBView,
  MDBRow,
  MDBCol,
  MDBCardBody,
  MDBIcon,
  MDBMedia,
  MDBSpinner,
  toast,
} from 'mdbreact';
import EXIF from 'exif-js';
import Compressor from 'compressorjs';
import api from '../../services/api';
import BotaoAbrirPdf from '../BotaoAbrirPdf';

function ImageMeta(props) {
  const [stateExifImage, setExifImage] = useState(null);
  // #31: múltiplas fotos numa seleção — array de { base64, data, view }
  const [fotos, setFotos] = useState([]);

  const [loadingSend, setLoadingSend] = useState(false);
  const [loadingBusca, setLoadingBusca] = useState(false);
  const [loadingHandle, setLoadingHandle] = useState(false);

  const [imagens, setImagens] = useState([]);
  const [imageSelected, setImageSelected] = useState(null);
  const [modalFoto, setModalFoto] = useState({ id: null, base: null });
  const [zoom, setZoom] = useState(1);
  const [dragOver, setDragOver] = useState(false); // #31 drag-and-drop
  const fileInputRef = useRef(null);
  // { id: null, base: null }
  // componentizar
  const buscaFotos = async () => {
    setLoadingBusca(true);
    // const result = await api.get('/sgo-imagem', {
    const result = await api.get(props.getFotos.buscaFotosURL, {
      params: {
        abordagem_id: props.abordagem_id,
        ...props.getFotos.buscaFotosWhere,
      },
    });

    setImagens(result.data);
    setLoadingBusca(false);
  };

  const handleZoomIn = () => {
    setZoom(zoom * 1.2); // Aumenta o zoom em 20%
  };

  const handleZoomOut = () => {
    setZoom(zoom / 1.2); // Diminui o zoom em 20%
  };

  const handleZoomReset = () => {
    setZoom(1); // Reseta o zoom para 100%
  };

  useEffect(() => {
    // #86: no modo buffer ainda não existe abordagem_id — nada a buscar.
    if (!props.bufferMode) buscaFotos();
  }, []);

  // #86: modo buffer — reporta a seleção ao formulário pai, que envia os
  // arquivos após criar a abordagem (em vez de postar aqui).
  useEffect(() => {
    if (props.bufferMode && props.onBufferChange) props.onBufferChange(fotos);
  }, [fotos]);

  useEffect(() => {
    handleChange(imageSelected);
  }, [imageSelected]);

  // componentizar
  const enviaFoto = async () => {
    if (fotos.length === 0) {
      return;
    }
    setLoadingSend(true);
    try {
      // #31: envia cada foto selecionada (cada uma com seu próprio EXIF).
      for (const foto of fotos) {
        await api.post(props.postFotos.enviarFotoURL, {
          file: foto.base64,
          data: foto.data,
        });
      }
    } catch (error) {
      console.log(error);
      setLoadingSend(false);
      return;
    }

    buscaFotos();
    setExifImage(null);
    setFotos([]);
    setLoadingSend(false);
  };

  const deletaFoto = async foto => {
    // setLoadingSend(true);

    // const result = await api.post('/sgo-insere-imagem', {

    const result = await api.delete(
      `${props.deleteFotos.deletarFotoURL}/${foto.id}`
    );
    if (result.data.ok) {
      toast.success(result.data.ok);
    }
    if (result.data.erro) {
      toast.error(result.data.erro);
    }

    setModalFoto({ id: null, base: null });
    buscaFotos();
    // buscaFotos();
    // setExifImage(null);
    // setExifData({});
    // setCompressedFileView(null);
    // setCompressedFileBase64(null);
    // setLoadingSend(false);
  };

  function converteCoord(grau, min, sec, dir) {
    // var parts = input.split(/[^\d\w\.]+/);

    let coord = Number(grau) + Number(min) / 60 + Number(sec) / (60 * 60);
    if (dir == 'S' || dir == 'O' || dir == 'W') {
      coord = coord * -1;
    }

    return coord;
  }

  // #31: processa 1 arquivo -> { base64, data, view } (EXIF + compressão) como Promise.
  function extraiExifEComprime(file) {
    return new Promise(resolve => {
      EXIF.getData(file, function() {
        // clona enviarRefId por arquivo (senão todas as fotos compartilham o mesmo objeto)
        const dados = { ...(props.postFotos && props.postFotos.enviarRefId) };
        const exifDataPretty = EXIF.pretty(this);
        const temMetadados = !!exifDataPretty; // #55 borda verde/laranja

        if (exifDataPretty) {
          const exifAllTags = EXIF.getAllTags(this);

          if (exifAllTags.DateTimeOriginal) {
            const trata = exifAllTags.DateTimeOriginal.split(' ');
            dados.exifdata = `${trata[0].split(':').join('-')} ${trata[1]}`;
          } else if (exifAllTags.DateTime) {
            const trata = exifAllTags.DateTime.split(' ');
            dados.exifdata = `${trata[0].split(':').join('-')} ${trata[1]}`;
          } else {
            dados.exifdata = null;
          }

          if (
            Object.keys(exifAllTags).length > 0 &&
            Object.keys(exifAllTags).indexOf('GPSLatitude') !== -1
          ) {
            dados.exiflatitude = converteCoord(
              exifAllTags['GPSLatitude'][0],
              exifAllTags['GPSLatitude'][1],
              exifAllTags['GPSLatitude'][2],
              exifAllTags['GPSLatitudeRef']
            );
          }

          if (
            Object.keys(exifAllTags).length > 0 &&
            Object.keys(exifAllTags).indexOf('GPSLongitude') !== -1
          ) {
            dados.exiflongitude = converteCoord(
              exifAllTags['GPSLongitude'][0],
              exifAllTags['GPSLongitude'][1],
              exifAllTags['GPSLongitude'][2],
              exifAllTags['GPSLongitudeRef']
            );
          }
        } else {
          dados.exifdata = null;
        }

        const quality = file.size > 200000 ? 0.6 : 1;
        new Compressor(file, {
          quality,
          maxHeight: 1024,
          maxWidth: 1024,
          success: compressedResult => {
            const reader = new FileReader();
            reader.readAsDataURL(compressedResult);
            reader.onload = () =>
              resolve({
                base64: reader.result,
                data: dados,
                view: compressedResult,
                temMetadados,
                isPdf: false,
              });
          },
          error: () => resolve(null),
        });
      });
    });
  }

  // #57: PDF vai direto (sem EXIF/compressão) -> { base64, view, isPdf:true }.
  function processaPdf(file) {
    return new Promise(resolve => {
      const dados = { ...props.postFotos.enviarRefId };
      dados.exifdata = null;
      const reader = new FileReader();
      reader.readAsDataURL(file);
      reader.onload = () =>
        resolve({
          base64: reader.result,
          data: dados,
          view: file,
          temMetadados: false,
          isPdf: true,
        });
      reader.onerror = () => resolve(null);
    });
  }

  function handleChange(files_list) {
    if (!files_list || files_list.length === 0) {
      return;
    }
    for (let i = 0; i < files_list.length; i += 1) {
      const tipo = files_list[i].type;
      if (
        tipo !== 'image/jpeg' &&
        tipo !== 'image/png' &&
        tipo !== 'application/pdf'
      ) {
        toast.error('Somente PNG, JPG, JPEG e PDF');
        return;
      }
    }

    // #31: respeita o limite total (existentes + já selecionadas + novas).
    const maxImages = props.maxImages || 10;
    const existentes = Array.isArray(imagens) ? imagens.length : 0;
    const disponiveis = maxImages - existentes - fotos.length;
    if (disponiveis <= 0) {
      toast.error(`Limite de ${maxImages} fotos atingido`);
      return;
    }
    let selecionados = Array.from(files_list);
    if (selecionados.length > disponiveis) {
      toast.error(`Só cabem mais ${disponiveis} foto(s); enviando as primeiras.`);
      selecionados = selecionados.slice(0, disponiveis);
    }

    setLoadingHandle(true);
    Promise.all(
      selecionados.map(f =>
        f.type === 'application/pdf' ? processaPdf(f) : extraiExifEComprime(f)
      )
    ).then(novas => {
      setFotos(prev => [...prev, ...novas.filter(Boolean)]);
      setLoadingHandle(false);
    });
  }

  // #31: separa imagens já anexadas dos documentos PDF (seções distintas)
  const galeriaItens = (Array.isArray(imagens) ? imagens : []).map(r => {
    const dataUrl = `${Buffer.from(r.imagem, 'base64')}`;
    return {
      res: r,
      dataUrl,
      ehPdf: dataUrl.startsWith('data:application/pdf'),
    };
  });
  const galeriaImagens = galeriaItens.filter(x => !x.ehPdf);
  const galeriaPdfs = galeriaItens.filter(x => x.ehPdf);

  return (
    <MDBContainer>
      {loadingBusca && (
        <MDBRow center className="align-items-center my-3">
          <MDBSpinner />
          <div className="ml-3 font-weight-bold">Carregando...</div>
        </MDBRow>
      )}
      <MDBRow>
        {imagens.ok ? (
          <MDBCol center className="py-3 font-weight-bold danger-text">
            {imagens.ok}
          </MDBCol>
        ) : (
          <MDBCol size="12">
            {galeriaImagens.length > 0 && (
              <>
                <div className="small font-weight-bold text-muted mt-2">
                  Imagens ({galeriaImagens.length})
                </div>
                <MDBRow>
                  {galeriaImagens.map(({ res, dataUrl }) => (
                    <MDBCol key={res.id} size="6" md="3" className="my-2">
                      <img
                        width="100"
                        height="100"
                        style={{ objectFit: 'cover' }}
                        className="cursor-pointer img-thumbnail"
                        src={dataUrl}
                        alt=""
                        onClick={() =>
                          setModalFoto({ id: res.id, base: res.imagem })
                        }
                      />
                    </MDBCol>
                  ))}
                </MDBRow>
              </>
            )}
            {galeriaPdfs.length > 0 && (
              <>
                <div className="small font-weight-bold text-muted mt-3">
                  Documentos ({galeriaPdfs.length})
                </div>
                <MDBRow>
                  {galeriaPdfs.map(({ res }) => (
                    <MDBCol key={res.id} size="6" md="3" className="my-2">
                      <div
                        className="cursor-pointer d-flex flex-column align-items-center justify-content-center border rounded text-danger p-2"
                        style={{ height: 100 }}
                        onClick={() =>
                          setModalFoto({ id: res.id, base: res.imagem })
                        }
                      >
                        <MDBIcon far icon="file-pdf" size="2x" />
                        <small>PDF</small>
                      </div>
                    </MDBCol>
                  ))}
                </MDBRow>
              </>
            )}
          </MDBCol>
        )}
      </MDBRow>

      {/* {imagens > 0 && console.log('console.log', URL.createObjectURL(imagens))} */}
      {/* {imagens > 0 && <img src={URL.createObjectURL(imagens)} />} */}

      {/* ))} */}
      {!props.readOnly &&
        (galeriaItens.length < (props.maxImages || 10) || imagens.ok ? (
        <div
          className="text-center my-2 rounded"
          style={{
            border: `2px dashed ${dragOver ? '#28a745' : '#bbb'}`,
            background: dragOver ? '#eafaf0' : '#fafafa',
            padding: '22px',
            cursor: 'pointer',
            transition: 'all .15s',
          }}
          onClick={() => fileInputRef.current && fileInputRef.current.click()}
          onDragOver={e => {
            e.preventDefault();
            if (!dragOver) setDragOver(true);
          }}
          onDragLeave={e => {
            e.preventDefault();
            setDragOver(false);
          }}
          onDrop={e => {
            e.preventDefault();
            setDragOver(false);
            if (e.dataTransfer.files && e.dataTransfer.files.length) {
              setImageSelected(Array.from(e.dataTransfer.files));
            }
          }}
        >
          <MDBIcon fas icon="upload" size="2x" className="text-muted mb-2" />
          <div className="font-weight-bold">Arraste imagens ou PDF aqui</div>
          <div className="small text-muted">
            ou clique para selecionar (JPG, PNG, PDF)
          </div>
          <input
            ref={fileInputRef}
            type="file"
            multiple
            accept=".jpg,.jpeg,.png,.pdf"
            style={{ display: 'none' }}
            onChange={e => {
              if (e.target.files && e.target.files.length) {
                // cópia estável: e.target.value=null esvazia o FileList vivo
                setImageSelected(Array.from(e.target.files));
              }
              // permite re-selecionar os mesmos arquivos depois
              e.target.value = null;
            }}
          />
        </div>
      ) : (
          <MDBRow center className="font-weight-bold danger-text">
            Limite: {props.maxImages || 10} fotos
          </MDBRow>
        ))}

      {!props.readOnly && <hr />}

      {(loadingHandle || fotos.length > 0) && (
        <MDBRow className="align-items-center justify-content-center">
          <MDBCol size="12">
            {loadingHandle ? (
              <div className="d-flex align-items-center justify-content-center">
                <MDBSpinner />
                <div className="ml-3 font-weight-bolder">Carregando...</div>
              </div>
            ) : (
              <>
                {fotos.some(f => !f.isPdf) && (
                  <>
                    <div className="small font-weight-bold text-muted w-100 text-center">
                      Imagens ({fotos.filter(f => !f.isPdf).length})
                    </div>
                    <MDBRow center>
                      {fotos.map((foto, i) =>
                        foto.isPdf ? null : (
                          <div key={i} className="position-relative m-1">
                            <img
                              className="img-thumbnail"
                              style={{
                                width: 100,
                                height: 100,
                                objectFit: 'cover',
                                border: `3px solid ${
                                  foto.temMetadados ? '#28a745' : '#fd7e14'
                                }`,
                              }}
                              src={URL.createObjectURL(foto.view)}
                              alt=""
                            />
                            <MDBIcon
                              icon="times-circle"
                              className="text-danger"
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                cursor: 'pointer',
                                background: 'white',
                                borderRadius: '50%',
                              }}
                              onClick={() =>
                                setFotos(prev =>
                                  prev.filter((_, idx) => idx !== i)
                                )
                              }
                            />
                          </div>
                        )
                      )}
                    </MDBRow>
                  </>
                )}
                {fotos.some(f => f.isPdf) && (
                  <>
                    <div className="small font-weight-bold text-muted w-100 text-center mt-2">
                      Documentos ({fotos.filter(f => f.isPdf).length})
                    </div>
                    <MDBRow center>
                      {fotos.map((foto, i) =>
                        !foto.isPdf ? null : (
                          <div key={i} className="position-relative m-1">
                            {/* #325: era <a href="data:..."> e não abria
                                nada — navegador bloqueia navegar para data:. */}
                            <BotaoAbrirPdf
                              dataUrl={foto.base64}
                              className="btn btn-outline-danger d-flex flex-column align-items-center justify-content-center m-0"
                              style={{ width: 100, height: 100 }}
                            >
                              <MDBIcon far icon="file-pdf" size="2x" />
                              <small>PDF</small>
                            </BotaoAbrirPdf>
                            <MDBIcon
                              icon="times-circle"
                              className="text-danger"
                              style={{
                                position: 'absolute',
                                top: 0,
                                right: 0,
                                cursor: 'pointer',
                                background: 'white',
                                borderRadius: '50%',
                              }}
                              onClick={() =>
                                setFotos(prev =>
                                  prev.filter((_, idx) => idx !== i)
                                )
                              }
                            />
                          </div>
                        )
                      )}
                    </MDBRow>
                  </>
                )}
              </>
            )}
          </MDBCol>
          {!props.bufferMode && (
          <MDBCol size="12" className="text-center mt-2">
            {loadingSend ? (
              <div className="d-flex align-items-center justify-content-center">
                <MDBSpinner />
                <div className="ml-3 font-weight-bolder">Enviando...</div>
              </div>
            ) : (
              <MDBBtn
                disabled={loadingSend || loadingHandle || fotos.length === 0}
                color="dark-green"
                size="sm"
                onClick={() => enviaFoto()}
              >
                Enviar{fotos.length > 1 ? ` (${fotos.length})` : ''}
              </MDBBtn>
            )}
          </MDBCol>
          )}
        </MDBRow>
      )}

      <MDBModal
        isOpen={modalFoto.id !== null}
        size="lg"
        toggle={() => {
          setModalFoto({ id: null, base: null });
        }}
      >
        <MDBModalHeader
          toggle={() => {
            setModalFoto({ id: null, base: null });
          }}
        >
          {props.readOnly ? 'Visualizar Arquivo' : 'Deletar Arquivo'}
        </MDBModalHeader>
        <MDBModalBody>
          {modalFoto.id !== null &&
            (`${Buffer.from(modalFoto.base, 'base64')}`.startsWith(
              'data:application/pdf'
            ) ? (
              // #31: visualizador de PDF integrado (iframe nativo do navegador)
              <div>
                <iframe
                  title="Visualizador de PDF"
                  src={`${Buffer.from(modalFoto.base, 'base64')}`}
                  style={{ width: '100%', height: '70vh', border: 'none' }}
                />
                <div className="text-center mt-2">
                  {/* #325: idem — o link com data: URL era inerte. */}
                  <BotaoAbrirPdf
                    dataUrl={`${Buffer.from(modalFoto.base, 'base64')}`}
                    className="btn btn-outline-danger btn-sm"
                  >
                    <MDBIcon far icon="file-pdf" className="mr-2" />
                    Abrir em nova aba
                  </BotaoAbrirPdf>
                </div>
              </div>
            ) : (
              <>
                <div style={{ overflow: 'auto' }}>
                  <img
                    className="w-100"
                    src={`${Buffer.from(modalFoto.base, 'base64')}`}
                    style={{
                      transform: `scale(${zoom})`,
                      transition: 'transform 0.3s ease',
                    }}
                  />
                </div>
                <MDBRow center style={{ marginTop: '20px' }}>
                  <MDBIcon
                    icon="search-plus"
                    size="2x"
                    className="mr-5"
                    style={{ cursor: 'pointer' }}
                    onClick={handleZoomIn}
                  />
                  <MDBIcon
                    icon="search-minus"
                    size="2x"
                    className="mr-5"
                    style={{ cursor: 'pointer' }}
                    onClick={handleZoomOut}
                  />

                  <MDBIcon
                    fas
                    icon="compress"
                    size="2x"
                    className="mr-5"
                    style={{ cursor: 'pointer' }}
                    onClick={handleZoomReset}
                  />
                </MDBRow>
              </>
            ))}
        </MDBModalBody>

        <MDBModalFooter between>
          <MDBBtn
            color="grey"
            onClick={() => {
              setModalFoto({ id: null, base: null });
            }}
          >
            FECHAR
          </MDBBtn>
          {!props.readOnly && (
            <MDBBtn
              color="danger"
              onClick={() => {
                // setModalFoto([]);
                deletaFoto(modalFoto);
              }}
            >
              Deletar
            </MDBBtn>
          )}
        </MDBModalFooter>
      </MDBModal>
    </MDBContainer>
  );
}

export default ImageMeta;
